import React from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import { black } from '../../../colors'
import { formatPercent } from '../../../utils/utils'
import ReportsChip from './ReportsChip'
import { type ICalculation } from '../../../models/Report'

const AVERAGE_LABEL = 'Average'

interface TopLevelSurveyResultProps {
  calculations: ICalculation[] | null | undefined
  titles?: string[]
}

export const TopLevelSurveyResult: React.FC<TopLevelSurveyResultProps> = ({ calculations, titles }) => {
  const theme = useTheme()

  if (calculations?.length === 0 && (!titles || titles.length <= 1)) return null

  return (
    <Box
      sx={{
        borderRadius: theme.spacing(2),
        padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <Box display={'flex'} flexDirection={'column'} gap={1} >
        <Typography variant="h6" color={black[100]} fontSize="22px" fontWeight="600">Survey Results </Typography>
        <Box display={'flex'} gap={2} flexWrap= 'wrap'>
          {titles && titles?.length > 1 && titles?.map((title, index) => (
            <ReportsChip
              key={index}
              index={index}
              label={title}
            />
          ))}
        </Box>
      </Box>
    {
      calculations && calculations.length > 0 &&
     <Box display="flex" flexDirection="column" gap={2} >
        {calculations?.map(({ name, values }) => {
          const label = name === AVERAGE_LABEL ? 'Overall Average' : name
          return (
            <Box
              key={name}
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: theme.spacing(2.5)
              }}
            >
              <Typography fontWeight={600} color={black[100]} whiteSpace={'nowrap'}>{label}:</Typography>
              {values?.map((value, index) => (
                <ReportsChip
                  key={index}
                  index={index}
                  label={name === AVERAGE_LABEL ? value : formatPercent(value)}
                />
              ))}
            </Box>
          )
        })}
      </Box>
       }
    </Box>
  )
}

export default TopLevelSurveyResult
